const MuiTabs = {
  styleOverrides: {
    root: {
      minHeight: 44,
    },
    indicator: {
      height: 3,
    },
  },
};

export default MuiTabs;
